import React from 'react'
import {clearAlertNotification} from 'redux/actions'
import {connect} from "react-redux";
import Alert from "./Alert";

function HookAlertPopup(
    {
        alertNotification,
        clearAlertNotification
    }) {


    const onClose = () => {
        if (alertNotification && alertNotification.onClose)
            alertNotification.onClose();
        clearAlertNotification();
    }

    return !!alertNotification && <Alert
        open
        onClose={onClose}
        confirmText={alertNotification.confirmText}
        confirmText2={alertNotification.confirmText2}
        translateTexts={alertNotification.translateTexts}
        title={alertNotification.title}
        maxWidth={alertNotification.maxWidth}
        buttonText={alertNotification.buttonText}
    />
}

export default connect((state) => ({
    alertNotification: state.store.alertNotification
}), {
    clearAlertNotification
})(HookAlertPopup);